
 import pdf from 'vue-pdf'

var loadingTask;

export default {
    name: 'BookletPDF',
    components: {
        pdf
    },
    data() {
        return {
            src: "",
            url : "",
            numPages: 0,
        }
    },
    mounted() {
        
    },
    created: async function(){
        this.$forceUpdate()

        var path = 'doc/doc/booklet/'
        //var path = '/doc/news/vtc/'   //for local testing

        var param = atob(this.$route.query.pdf) + ".pdf";
        console.log(param)

        var file = path + param
        this.url = file;

        var xhr = new XMLHttpRequest()
        xhr.open('HEAD', file, false)
        xhr.send()

        console.log(xhr.status)

        var xRobotsTag = xhr.getResponseHeader('X-Robots-Tag')
        console.log('X-Robots-Tag:', xRobotsTag)
        if (!xRobotsTag) {
          console.warn('X-Robots-Tag header is missing for file:', file)
        }

        if(xhr.status == '404'){
            alert('File is not existed. Please help to check with IT')
        }else{
          loadingTask = await pdf.createLoadingTask(file);
          this.src = loadingTask
          await this.src.promise.then(pdf => {
            this.numPages = pdf.numPages;
          });
        }
    },
    methods: {
      async DownloadPdf(url){
        window.open(url, '_blank');
      }
    }
}
 
